var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    stroke: "#2C67F1",
    strokeWidth: 1.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20964 5.45833L8.41946 3.87798C8.19205 3.42315 8.07833 3.19573 7.90869 3.02957C7.75867 2.88264 7.57786 2.7709 7.37936 2.70243C7.15488 2.625 6.90062 2.625 6.39209 2.625H3.68464C2.89123 2.625 2.49452 2.625 2.19148 2.77941C1.92492 2.91523 1.7082 3.13195 1.57238 3.39851C1.41797 3.70156 1.41797 4.09826 1.41797 4.89167V5.45833M1.41797 5.45833H12.1846C13.3747 5.45833 13.9698 5.45833 14.4244 5.68994C14.8242 5.89368 15.1493 6.21876 15.353 6.6186C15.5846 7.07317 15.5846 7.66822 15.5846 8.85833V11.975C15.5846 13.1651 15.5846 13.7602 15.353 14.2147C15.1493 14.6146 14.8242 14.9397 14.4244 15.1434C13.9698 15.375 13.3747 15.375 12.1846 15.375H4.81797C3.62786 15.375 3.0328 15.375 2.57824 15.1434C2.17839 14.9397 1.85331 14.6146 1.64958 14.2147C1.41797 13.7602 1.41797 13.1651 1.41797 11.975V5.45833ZM8.5013 12.5417V8.29167M6.3763 10.4167H10.6263",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPlus);
export default __webpack_public_path__ + "static/media/folder-plus.f301e8886ce7d73320e7b87478b0c648.svg";
export { ForwardRef as ReactComponent };